//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models

import com.tixforgigs.apax.models.PreviewEvent

        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The template config model
* 
* @param embedCode The embed code
* @param events The events
*/
@Serializable

data class PreviewData (


      /* The embed code */
    @SerialName(value = "embedCode") @Required val embedCode: kotlin.String,


      /* The events */
    @SerialName(value = "events") val events: kotlin.collections.List<PreviewEvent>? = null


) {




  }

